/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SEmbedSessionTokens
 */
export interface SEmbedSessionTokens {
    /**
     * 
     * @type {string}
     * @memberof SEmbedSessionTokens
     */
    accessToken: string;
    /**
     * 
     * @type {string}
     * @memberof SEmbedSessionTokens
     */
    refreshToken: string;
    /**
     * 
     * @type {number}
     * @memberof SEmbedSessionTokens
     */
    expiresIn: number;
}

/**
 * Check if a given object implements the SEmbedSessionTokens interface.
 */
export function instanceOfSEmbedSessionTokens(value: object): value is SEmbedSessionTokens {
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined) return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined) return false;
    return true;
}

export function SEmbedSessionTokensFromJSON(json: any): SEmbedSessionTokens {
    return SEmbedSessionTokensFromJSONTyped(json, false);
}

export function SEmbedSessionTokensFromJSONTyped(json: any, ignoreDiscriminator: boolean): SEmbedSessionTokens {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'],
        'refreshToken': json['refreshToken'],
        'expiresIn': json['expiresIn'],
    };
}

export function SEmbedSessionTokensToJSON(json: any): SEmbedSessionTokens {
    return SEmbedSessionTokensToJSONTyped(json, false);
}

export function SEmbedSessionTokensToJSONTyped(value?: SEmbedSessionTokens | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessToken': value['accessToken'],
        'refreshToken': value['refreshToken'],
        'expiresIn': value['expiresIn'],
    };
}

